<template>
  <div v-if="showDiscountCondition">
    <div class="name">
      <slot name="txtCurrentBillDiscount">{{ description }}</slot>
    </div>
    <div class="price">- {{ price(discount) }}</div>
  </div>
</template>

<script>
import promoContext from '@/mixins/promoContext'
import price from '@/mixins/formatters/price'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'PromoCurrentBillDiscount',
  data () {
    return {
      showDiscount: false
    }
  },
  mixins: [
    promoContext,
    useFeature('showFeaturePromotion'),
    price,
    dateFormatter
  ],
  props: {
    default: {
      required: true,
      type: Boolean
    },
    description: {
      required: false,
      type: String
    },
    discount: {
      required: true,
      type: Number
    },
    expirationDate: {
      required: false,
      type: String
    }
  },
  mounted () {
    if (typeof this.discount === 'number') {
      this.showDiscount = true
    }
  },
  computed: {
    showDiscountCondition () {
      return this.showDiscount && this.showFeaturePromotion
    }
  }
}
</script>
